// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Panel":"bcv_a bho_ea bho_ke bho_ju bho_sn bho_wl"};